import React from 'react';

const ServiceDepartment = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['construction', 'engineering', 'precision_manufacturing', 'settings', 'build', 'handyman', 'plumbing', 'thermostat'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Professional Services
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Service Department
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Service = Total Customer Care
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Total Customer Care */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Service Solutions at Bel-Aire Mechanical</h2>
            <p>Total Customer Care for all your HVAC-R and Plumbing/Piping needs</p>
          </div>
          
          <div className="service-department-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'start', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Bel-Aire Mechanical designed its Service Department with one thing in mind – <strong style={{color: 'var(--primary-black)'}}>Total Customer Care</strong>. No matter your HVAC-R or Plumbing/Piping needs, we've got you covered! Be it emergency repairs, equipment retrofits, tenant improvements, or preventative maintenance, we have skilled technicians on staff to meet your unique situation and requirements.
              </p>
            </div>
            
            <div style={{height: '300px', borderRadius: '10px', overflow: 'hidden'}}>
              <img 
                src="/images/all pictures/Service2.jpg" 
                alt="Bel-Aire Mechanical Service Team" 
                style={{width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', transform: 'scale(1.2)', borderRadius: '10px'}}
              />
            </div>
          </div>

          <div className="service-department-card" style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
            <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
              Over the last ten years, we've assembled one of the strongest teams of technicians in the industry boasting nearly <strong>600 years of combined know-how</strong>. They bring a wealth of diverse experience across a variety of equipment types, sizes and manufacturers. Each is in possession of state-of-the-art diagnostic and communication tools to increase their efficiency and deliver reliable solutions and exceptional customer satisfaction.
            </p>
          </div>

          <div className="service-department-card" style={{background: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', border: '2px solid var(--accent-blue)'}}>
            <h3 style={{fontSize: '1.5rem', marginBottom: '1.5rem', color: 'var(--accent-blue)'}}>We Can Deliver:</h3>
            <div className="service-deliver-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                <span style={{color: 'var(--accent-blue)', fontSize: '1.2rem'}}>✓</span>
                <span>Emergency response via our 24/7 live dispatch service</span>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                <span style={{color: 'var(--accent-blue)', fontSize: '1.2rem'}}>✓</span>
                <span>Highly trained technical staff</span>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                <span style={{color: 'var(--accent-blue)', fontSize: '1.2rem'}}>✓</span>
                <span>Knowledgeable and responsive support staff</span>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                <span style={{color: 'var(--accent-blue)', fontSize: '1.2rem'}}>✓</span>
                <span>Independent and custom approaches to your facility needs</span>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                <span style={{color: 'var(--accent-blue)', fontSize: '1.2rem'}}>✓</span>
                <span>Timely follow-up on needed repairs</span>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                <span style={{color: 'var(--accent-blue)', fontSize: '1.2rem'}}>✓</span>
                <span>Competitive Rates</span>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                <span style={{color: 'var(--accent-blue)', fontSize: '1.2rem'}}>✓</span>
                <span>Uncomplicated and flexible terms</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Technician Expertise */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Technician Expertise</h2>
            <p style={{fontSize: '1.15rem', maxWidth: '900px', margin: '0 auto'}}>
              Not only have our technicians spent years perfecting their craft through on the job experience, they've also dedicated time to obtaining factory and industry training and certification. They've collectively compiled over <strong style={{color: 'var(--accent-blue)'}}>120+ certifications</strong>, including:
            </p>
          </div>
          
          <div className="service-department-grid-3col" style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem'}}>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent-blue)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent-blue)'}}>OEM Factory Certifications</h3>
              <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Trane, York, Daikin, Carrier, Yaskawa, ABB, etc.</p>
            </div>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent2-red)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent2-red)'}}>Boiler Operations and Maintenance</h3>
            </div>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent-blue)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent-blue)'}}>Chillers</h3>
              <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Centrifugal, Screw, Scroll and Reciprocating</p>
            </div>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent2-red)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent2-red)'}}>Turbocor Troubleshooting and Repair</h3>
            </div>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent-blue)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent-blue)'}}>Micro-controls Troubleshooting</h3>
            </div>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent2-red)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent2-red)'}}>Packaged RTU's</h3>
            </div>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent-blue)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent-blue)'}}>Startup and Commissioning</h3>
            </div>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent2-red)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent2-red)'}}>Variable Air Volume (VAVs)</h3>
            </div>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent-blue)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent-blue)'}}>Variable Frequency Drives (VFDs)</h3>
            </div>
            <div className="service-cert-card" style={{background: 'var(--white)', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', borderLeft: '4px solid var(--accent2-red)'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '0.75rem', color: 'var(--accent2-red)'}}>Pump/Motor Teardown and Repair</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Critical Markets */}
      <section className="section" style={{background: 'var(--white)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Mission Critical Markets We Serve</h2>
            <p style={{fontSize: '1.15rem', maxWidth: '900px', margin: '0 auto'}}>
              Bel-Aire Mechanical is gratified to say that our service capabilities, experience and reputation are constantly growing. Our customers come from a variety of Mission Critical markets.
            </p>
          </div>
          <div className="service-department-grid-3col" style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2rem'}}>
            <div className="service-market-card" style={{background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 6px 20px rgba(0, 104, 166, 0.2)', transition: 'transform 0.3s ease'}}>
              <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>precision_manufacturing</span></div>
              <h3 style={{fontSize: '1.4rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Industrial/Manufacturing</h3>
              <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Specialized systems for production facilities and manufacturing plants.</p>
            </div>
            <div className="service-market-card" style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 6px 20px rgba(171, 22, 54, 0.2)', transition: 'transform 0.3s ease'}}>
              <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>dns</span></div>
              <h3 style={{fontSize: '1.4rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Data Centers</h3>
              <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Critical cooling and environmental control systems.</p>
            </div>
            <div className="service-market-card" style={{background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 6px 20px rgba(0, 104, 166, 0.2)', transition: 'transform 0.3s ease'}}>
              <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>local_hospital</span></div>
              <h3 style={{fontSize: '1.4rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Hospitals/Healthcare</h3>
              <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Advanced HVAC systems for medical facilities and patient care.</p>
            </div>
            <div className="service-market-card" style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 6px 20px rgba(171, 22, 54, 0.2)', transition: 'transform 0.3s ease'}}>
              <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>school</span></div>
              <h3 style={{fontSize: '1.4rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Universities & K-12 Schools</h3>
              <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Educational facility climate control and mechanical systems.</p>
            </div>
            <div className="service-market-card" style={{background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 6px 20px rgba(0, 104, 166, 0.2)', transition: 'transform 0.3s ease'}}>
              <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>business</span></div>
              <h3 style={{fontSize: '1.4rem', marginBottom: '0.75rem', color: 'var(--white)'}}>High-End Commercial</h3>
              <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Premium commercial building systems and maintenance.</p>
            </div>
            <div className="service-market-card" style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 6px 20px rgba(171, 22, 54, 0.2)', transition: 'transform 0.3s ease'}}>
              <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>casino</span></div>
              <h3 style={{fontSize: '1.4rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Casinos</h3>
              <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>24/7 operation support for gaming and hospitality facilities.</p>
            </div>
            <div className="service-market-card" style={{background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 6px 20px rgba(0, 104, 166, 0.2)', transition: 'transform 0.3s ease', gridColumn: 'span 1'}}>
              <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>stadium</span></div>
              <h3 style={{fontSize: '1.4rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Sports/Concert Venues</h3>
              <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Large-scale HVAC for entertainment and athletic facilities.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: HVAC Service */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>HVAC Service, Repair and Maintenance</h2>
            <p>Specialized expertise across all HVAC system types and sizes</p>
          </div>
          
          <div className="service-department-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}}>
                  <div style={{height: '550px', borderRadius: '10px', overflow: 'hidden'}}>
              <img 
                src="/images/all pictures/Service3.jpg" 
                alt="Bel-Aire Mechanical Service Team" 
                style={{width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', borderRadius: '10px'}}
              />
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                HVAC service, repair and maintenance is Bel-Aire Service Department's specialty. Our highly trained technicians perform work on all of the following systems:
              </p>
              
              <div className="service-info-box" style={{background: 'var(--accent-blue)', color: 'var(--white)', padding: '2rem', borderRadius: '10px', marginBottom: '1.5rem'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>System Types</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.95)', fontSize: '0.95rem', lineHeight: '1.7'}}>
                  Chillers and Central Cooling Systems, Cooling Towers, Circulation Pumps, Boilers, Data Center Specialty Cooling, Process Cooling, MRI/CT Cooling, Humidification, Package Equipment, Split Systems, Water Source Heat Pumps, VAV Systems, Air Purification and more.
                </p>
              </div>

              <div className="service-info-box" style={{background: 'var(--accent2-red)', color: 'var(--white)', padding: '2rem', borderRadius: '10px'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>Size Range</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.95)', fontSize: '0.95rem', lineHeight: '1.7'}}>
                  Full Range from Small to Mid-Size Commercial Units such as 5-ton Packaged Units to 2,000-ton Chillers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Piping and Plumbing */}
      <section className="section" style={{background: 'var(--secondary-light)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Piping and Plumbing Service and Repair</h2>
            <p>Comprehensive solutions for all your facility needs</p>
          </div>
          
          <div className="service-department-grid-4col" style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem', marginBottom: '3rem'}}>
            <div className="service-department-card" style={{background: 'var(--white)', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', textAlign: 'center'}}>
              <h3 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)'}}>Underground Leak Repair</h3>
            </div>
            <div className="service-department-card" style={{background: 'var(--white)', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', textAlign: 'center'}}>
              <h3 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)'}}>Valve and Piping Replacement</h3>
            </div>
            <div className="service-department-card" style={{background: 'var(--white)', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', textAlign: 'center'}}>
              <h3 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)'}}>Backflow Testing/Certification</h3>
            </div>
            <div className="service-department-card" style={{background: 'var(--white)', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', textAlign: 'center'}}>
              <h3 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)'}}>Commercial Fixture Installation</h3>
            </div>
            <div className="service-department-card" style={{background: 'var(--white)', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', textAlign: 'center'}}>
              <h3 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)'}}>Sewer Cleaning/Snaking</h3>
            </div>
            <div className="service-department-card" style={{background: 'var(--white)', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', textAlign: 'center'}}>
              <h3 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)'}}>Sewer Camera Scoping</h3>
            </div>
            <div className="service-department-card" style={{background: 'var(--white)', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', textAlign: 'center'}}>
              <h3 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)'}}>Emergency Pipe Fabrication</h3>
            </div>
            <div className="service-department-card" style={{background: 'var(--white)', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', textAlign: 'center'}}>
              <h3 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)'}}>On-Site Welding</h3>
            </div>
          </div>
          
          <div style={{height: '550px', borderRadius: '10px', overflow: 'hidden'}}>
              <img 
                src="/images/all pictures/Service7.jpg" 
                alt="Bel-Aire Mechanical Service Team" 
                style={{width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center', borderRadius: '10px'}}
              />
            </div>
        </div>
      </section>
      
    </div>
  );
};

export default ServiceDepartment;
